import { Construtor } from './construtor';
import { ProcessoSetor } from './processo-setor';
import { RotinaCliente } from './rotina-cliente';

export class RotinaProcesso implements Construtor<RotinaProcesso> {

  public idRotinaProcesso: number;
  public processoSetor: ProcessoSetor;
  public rotinaCliente: RotinaCliente;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {

    this.rotinaCliente = new RotinaCliente();
    this.processoSetor = new ProcessoSetor();

    if (object !== undefined) {
      if (object instanceof (RotinaProcesso)) {
        this.copyObject(object);
      } else if (object instanceof (RotinaCliente)) {
        this.rotinaCliente = object;
      } else if (object instanceof (ProcessoSetor)) {
        this.processoSetor = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdRotinaProcesso(id: any) {
    this.idRotinaProcesso = id;
  }

  set RotinaCliente(rotinaCliente: any) {
    this.rotinaCliente = rotinaCliente;
  }

  set ProcessoSetor(processoSetor: any) {
    this.processoSetor = processoSetor;
  }

  parseFromJson(processoSetor: any): void {
    this.IdRotinaProcesso = processoSetor.idRotinaProcesso;
    this.RotinaCliente = processoSetor.rotinaCliente;
    this.ProcessoSetor = processoSetor.processoSetor;
  }

  copyObject(processoSetor: RotinaProcesso): void {
    this.idRotinaProcesso = processoSetor.idRotinaProcesso;
    this.rotinaCliente = processoSetor.rotinaCliente;
    this.processoSetor = processoSetor.processoSetor;
  }

  modeloCompleto(): boolean {
    return this.rotinaCliente.modeloCompleto();
  }

  getNewInstance(object?: any): RotinaProcesso {
    return new RotinaProcesso(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/rotina-processo.ts